<template>

  <div id="requetesAnomalie">
    <table class="modal-requeteIn">

      <tbody>
      <tr>
        <td class ="infoRequete col-lg-10 col-md-9">
          <p class="titreRequeteExecption pr-2"><strong>{{requete.titre}}</strong> : {{requete.message}}</p>
          <p class="titreRequeteExecption mt-3"><strong>{{requete.ligneAno}}</strong> anomalie(s) - <strong>{{requete.justif}}</strong> justifiées -
            <strong>{{requete.justifValid}}</strong> validées - <strong>{{requete.justifInvalid}}</strong> refusées
          </p>
        </td>
        <td class="btnRequete col-lg-2 col-md-3" title= "visualiser les lignes anomalies de la requête">
          <b-button pill @click.prevent ="handleShowModalAnomalieIn(idExecution,requete.idRequete)" align-self="center"
                    class="nav-link1">anomalies <i class="fas fa-arrow-alt-circle-down"></i>
          </b-button>
        </td>
      </tr>
      <div v-if="showModalAnomalieIn" class="col-md-12">
        <div v-if="anomalies.length!==0">
          <ModalAnomalieFromRequetesInExecution
              :idExecution="idExecution"
              :idRequete="requete.idRequete"
              :anomalies="anomalies"
              :nomChamps = "nomChamps"
          >
          </ModalAnomalieFromRequetesInExecution>
        </div>
        <div class = "loading2" v-if="!loaded">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <span class="ml-2">Chargement en cours...</span>
        </div>
      </div>
      </tbody>
    </table>
  </div>

</template>

<script>
import useRequeteItem from "@/composition/Rapports/requetesInExecution";
import ModalAnomalieFromRequetesInExecution from '@/components/Rapports/AnomalieFromRequetesInExecution';
export default {
  name: 'RequeteItem',

  components:{
    ModalAnomalieFromRequetesInExecution,
  },

  props: {
    requete:{
      required:true,
      type:Object
    },
    idExecution:{
      type:Number
    }
  },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props){
    return useRequeteItem(props);
  },
};
</script>

<style>
.nav-link1{
  color: white !important;
  font-size: 25px;
}
.nav-link1:hover{
  color: black !important;
}
.titreRequeteExecption{
  color: black;
  font-size: 13px;
}

.infoRequete{
  padding-right: 20px;
  padding-left: 20px;
}

.modal-requeteIn {
  border-radius: 10px;
  background-color: white;
  min-width: 100%;
}
.loading2{
  color: black !important;
}
</style>